import React from "react";
import textAbout from "assets/about.json";
import OutlinedText from "common/OutlinedText";
import Slider from "components/video-slider/Slider";
import Image from "assets/images/Banner_nosotros.jpg";
import AboutImage from "assets/images/questions/Nosotros.webp";
import "styles/about.css";

const About = () => {
  return (
    <section>
      <img src={Image} alt="Elite vacances" className="image-banner-elite" />

      <article>
        <div className="section-text">
          <OutlinedText
            text1="Nosotros"
            text2="Nosotros"
            color="var(--azul-gac)"
            bottom_text1="40%"
            left_text1="20%"
            bottom_text2="50%"
            left_text2="22%"
          />
        </div>
        <div className="container-about">
          <img
            className="image-about"
            src={AboutImage}
            alt="Acerca de nosotros"
          />

          <div className="container-main-text">
            <h1 className="title-content">¿Quiénes somos?</h1>
            <p className="text-content-about">
              Elite Vacances es una marca creada para transformar la manera en
              que vives tus viajes. Somos una empresa especializada en
              vacaciones de lujo, experiencias exclusivas y destinos
              cuidadosamente seleccionados, pensada para quienes buscan mucho
              más que un simple viaje: buscan momentos inolvidables.
            </p>
            <p className="text-content-about">
              Más que viajar… es vivir diferente. En Elite Vacances creemos que
              cada escapada debe sentirse más que única y diferente. Por eso
              diseñamos experiencias personalizadas que combinan:
            </p>
            <ul className="text-content-about">
              <li>Hospedajes premium</li>
              <li>Destinos paradisíacos</li>
              <li>Atención preferencial</li>
              <li>Beneficios exclusivos</li>
              <li>Planes pensados para cada estilo de vida</li>
            </ul>

            <a
              href="https://api.whatsapp.com/send?phone=5717945996"
              target="_blank"
              className="btn-about-contact"
              data-tooltip="WhatsApp"
              rel="noopener noreferrer"
            >
              Contáctanos
            </a>
          </div>
        </div>
      </article>

      <Slider
        showAlternButtons={true}
        showIndicators={false}
        showButtons={false}
      >
        {textAbout.map(({ title, text, image }, index) => (
          <div className="vision-section" key={index}>
            <div className="vision-text">
              <OutlinedText
                text1={title}
                text2={title}
                color="#000"
                positionTop1="9%"
                left_text1={`${
                  index === 1 ? "115%" : index === 2 ? "215%" : "15%"
                }`}
                positionTop2="5%"
              />
              <div className="description-text">
                <p dangerouslySetInnerHTML={{ __html: text }}></p>
              </div>
            </div>
            <div className="vision-image">
              <img className="vision-image" src={image} alt={title} />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default About;
